export const light = 300;
export const normal = 400;
export const medium = 500;
export const semibold = 600;
export const bold = 700;
